export { default as tenantProvider } from './tenantProvider';
export { default as tenantConfiguratinService } from './tenantConfiguratinService';
export * from './tenantDomains';

